/** Streaming / tool status under the Ask Insights thread. */
export function AiStatusLine({ label }: { label: string | null }) {
  if (!label) return null;
  return (
    <p className="px-1 text-xs text-muted-fg" aria-live="polite">
      {label}
    </p>
  );
}
